module.exports = __webpack_public_path__ + "media/img/frontend_application/coupon-red-07a60383b0c6b55724f21bdf22a9de91.png";